@if (showBanner()) {
  <div class="plan-expiry-banner" [class]="urgencyClass()" role="alert" aria-live="polite">
    <div class="banner-inner">

      <!-- Icono de alerta -->
      <div class="banner-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
          <line x1="12" y1="9" x2="12" y2="13"/>
          <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
      </div>

      <!-- Mensaje -->
      <div class="banner-content">
        <span class="banner-label">Aviso de vencimiento</span>
        <p class="banner-text" [innerHTML]="bannerMessage()"></p>
      </div>

      <!-- Acciones -->
      <div class="banner-actions">
        <button class="btn-upgrade" (click)="goToPlans()" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"
               class="btn-icon" aria-hidden="true">
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
            <polyline points="17 6 23 6 23 12"/>
          </svg>
          Mejorar mi plan
        </button>

        <button class="btn-dismiss" (click)="dismiss()" type="button" aria-label="Cerrar aviso">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
               aria-hidden="true">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>

    </div>
  </div>
}
